module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Aidan-Chan-7b38962f61e58e86262815016e23b52f.jpg";